var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal--cta",attrs:{"id":"modal-switch-to-annual-prompt"}},[_c('h3',[_vm._v("\n        "+_vm._s(_vm.pageAttribute.get(
                'switch_prompt_header',
                'Switch plan and remove SHOWTIME?'
            ))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"modal--body",domProps:{"innerHTML":_vm._s(_vm.disclaimer)}}),_vm._v(" "),_c('ButtonCta',{attrs:{"buttonConfig":_vm.submitConfig}}),_vm._v(" "),_c('ButtonCta',{attrs:{"buttonConfig":_vm.cancelConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }